module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=RU - Russian Federation.51a90b10.svg";